const formatBalanceCashFlows = balance => ({
  currentResult: balance.current?.result?.CLP || 0,
  result: balance.aggregated?.gainLoss?.CLP || 0,
  variation: balance.aggregated?.gainLoss?.CLP || 0,
  totalSubscriptions: balance.subscribed?.total?.CLP || 0,
  subscriptions: balance.subscribed?.subscriptions?.CLP || 0,
  reinvestmentSubscriptions: balance.subscribed?.reinvestmentSubscriptions?.CLP || 0,
  current: balance.current?.balance?.CLP || 0,
  totalRedemptions: balance.redeemed?.total?.CLP || 0,
  redemptions: balance.redeemed?.redemptions?.CLP || 0,
  reinvestmentRedemptions: balance.redeemed?.reinvestmentRedemptions?.CLP || 0,
  distributions: balance.redeemed?.distributions?.CLP || 0,
  currentReinvestedDistributions: balance.current?.reinvestedDistributions?.CLP || 0,
  reinvestedDistributions: balance.subscribed?.reinvestedDistributions?.CLP || 0,
  realizedResult: balance.redeemed?.result?.CLP || 0,
  netSubscriptions: balance.aggregated?.netSubscriptions?.CLP || 0,
  netRedemptions: balance.aggregated?.netRedemptions?.CLP || 0,
});

export default {
  methods: {
    formatFundSeriesBalances(balancesStateFundSeries) {
      if (!balancesStateFundSeries || !balancesStateFundSeries.length) {
        return [];
      }
      return balancesStateFundSeries.map(fundSeriesBalance => {
        const { date, balance, fundSeries } = fundSeriesBalance;
        const { shareValue, exchangeRate } = balance;
        return {
          balanceDate: date,
          ...formatBalanceCashFlows(balance),
          currencyAmount: balance.current?.balance?.CLP || 0,
          quotasAmount: balance.current?.balance?.shares || 0,
          quotaValue: shareValue?.[fundSeries?.currency] || 0,
          clpQuotaValue: shareValue?.CLP || 0,
          exchangeRate: exchangeRate?.USDCLP || 0,
          currency: fundSeries?.currency,
          id: fundSeries.fund.id,
          run: fundSeries.fund.run,
          fundRun: fundSeries.fund.run,
          shortName: fundSeries.fund.shortName,
          symbol: fundSeries.symbol,
          seriesName: fundSeries.seriesName,
          fundSeriesId: fundSeries.id,
          isSeriesActive: fundSeries.active,
        };
      });
    },

    formatTotalBalances(totalBalances) {
      if (!totalBalances) {
        return {
          balanceDate: null,
          currentResult: 0,
          result: 0,
          variation: 0,
          subscriptions: 0,
          totalSubscriptions: 0,
          reinvestmentSubscriptions: 0,
          current: 0,
          redemptions: 0,
          reinvestmentRedemptions: 0,
          totalRedemptions: 0,
          distributions: 0,
          currentReinvestedDistributions: 0,
          reinvestedDistributions: 0,
          realizedResult: 0,
          netSubscriptions: 0,
          netRedemptions: 0,
        };
      }
      return {
        balanceDate: totalBalances.date,
        ...formatBalanceCashFlows(totalBalances),
      };
    },
  },
};
